import axios from 'axios';
import {CLIENT_CREDENTIAL, TTP_API_URL} from 'Config';

export const getTTPUser = (userId, token, ignorePermissionFilter = 0) => {
  const filter = [
    {
      property: 'id',
      value: userId,
      operator: 'eq',
    },
  ];
  const fields = ['*', 'email', 'avatar', 'description', 'cover', 'url', 'clients', 'paymentClients', 'roles'];
  const requestUrl = `${TTP_API_URL}/organization/user`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(','),
  };

  if (ignorePermissionFilter === 1) {
    params.ignorePermissionFilter = 1;
  }

  return axios.get(requestUrl, {
    params,
  });
  /*return $.ajax({
    async: false,
    url: requestUrl,
    data: params
  });*/
};

export const getClientCredential = () => {
  const requestUrl = `${TTP_API_URL}/token`;
  var resultat= $.ajax({
    type: 'POST',
    url: requestUrl,
    data: CLIENT_CREDENTIAL,
  });
  return resultat;
};

export const setSelectedOrganization = (token, client) => {
  const requestUrl = `${TTP_API_URL}/organization/user/save-selected-organization`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", client.id);

  return axios.post(requestUrl, formData);
};

export const fetchTTPUserByToken = (token) => {
  const fields = ['*', 'email', 'avatar', 'description', 'cover', 'url', 'clients', 'paymentClients', 'roles'];

  const requestUrl = `${TTP_API_URL}/organization/user/getCurrentUser`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields: fields.join(','),
    },
  });
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/auth.js